module.exports = __webpack_public_path__ + "img/copied.606cadbd.svg";